import React from 'react';
import ReportingDonationsOutstandingPledgesPage from '../components/ReportingDonationsOutstandingPledgesPage';

const ReportingDonationsOutstandingPledgesApp = (props) => (
  <ReportingDonationsOutstandingPledgesPage {...props} />
);

export default ReportingDonationsOutstandingPledgesApp;
